export const useListHeaders = ({ columns }) => [
  {
    id: 'defaultFooter',
    columns: Object.keys(columns).map(column => ({
      column,
      ...columns[column]
    }))
  }
];
